<template>
  <div>
    页面跳转中，请稍后...
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "ToSms",
  data() {
    return {
      ticket: null,
      backUrl: null
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/system/JumpToSmsReport.vue